import { Badge, Box, Tooltip } from '@wix/design-system';
import React from 'react';
import { dataHooks } from '../../utils/datahooks';
export const IssueBadge = _ref => {
  let {
    label,
    tooltipContent,
    datahook,
    tooltipEnterDelay = 0,
    badgeSize = 'small',
    onTooltipShow
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    height: "SP6",
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    content: tooltipContent,
    disabled: !tooltipContent,
    enterDelay: tooltipEnterDelay,
    size: "small",
    onShow: onTooltipShow
  }, /*#__PURE__*/React.createElement(Badge, {
    dataHook: dataHooks.issueCounterBadge(datahook),
    size: badgeSize,
    skin: "danger",
    type: "outlined",
    uppercase: false
  }, label)));
};
//# sourceMappingURL=issue-badge.js.map